import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {TemplateNode} from "#template/template-node/template-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import {S3Variable} from "#template/nodes/variable/s3-variable"

export type BallRotationParameters = {
    rotation: S3Variable
}

const ballRotationDefinition: TemplateNodeDefinition<BallRotationParameters> = {
    nodeClass: "BallRotation",
    validation: {
        parameters: z.object({rotation: graphNode(S3Variable)}),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class BallRotation extends TemplateNode<BallRotationParameters> {
    public override get definition() {
        return ballRotationDefinition
    }
}
